import React from 'react'
import Navbar from '../component/Navbar'

const PrivacyPolicy = () => {
    return (
        <>
            <Navbar />
            <div style={{marginTop:"10%"}}>PrivacyPolicy</div>

        </>
    )
}

export default PrivacyPolicy
